var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "50px",
        height: "82px",
        viewBox: "0 0 50 82",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          staticStyle: { stroke: "rgb(${darkerColor})" },
          attrs: {
            id: "locator_base",
            "stroke-width": "1",
            "stroke-linejoin": "round",
            "stroke-linecap": "round",
            fill: "${color}",
            "fill-rule": "evenodd"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M25,2.13162821e-14 C38.8071187,2.13162821e-14 50,10.0632416 50,25.5316208 C50,35.8438736 41.6666667,54.6666667 25,82 C8.33333333,54.6666667 0,35.8438736 0,25.5316208 C0,10.0632416 11.1928813,2.13162821e-14 25,2.13162821e-14 Z M25,15 C19.4771525,15 15,19.4771525 15,25 C15,30.5228475 19.4771525,35 25,35 C30.5228475,35 35,30.5228475 35,25 C35,19.4771525 30.5228475,15 25,15 Z",
              id: "locator"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }